<template>
  <Wrapper>
    <figure class="slider__list">
      <img
        class="slider-img"
        src="../../../assets/images/sp-main-visual.png"
        alt=""
      />
    </figure>
    <FlowParticipation :lang="lang" :langPath="langPath"></FlowParticipation>
       <NoticeList
         :lang="lang"
         :langPath="langPath"
         v-if="showNotice && lang == 'ja'"
       ></NoticeList>
    <EventList :lang="lang" :langPath="langPath"></EventList>
    <TokyoMarathonFoundation :langPath="langPath"></TokyoMarathonFoundation>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
import FlowParticipation from "../../../components/sp/top/FlowParticipation";
import EventList from "../../../components/sp/top/EventList";
import NoticeList from "../../../components/sp/top/NoticeList";
import TokyoMarathonFoundation from "../../../components/sp/top/TokyoMarathonFoundation";
export default {
  data() {
    return {
      showNotice: true,
    };
  },
  mounted() {
    // NOTE NOTICEの時間指定があった時用
    // const currentDate = new Date();
    // if (currentDate < Date.parse("2021-03-18T09:55:00")) {
    //   this.showNotice = true;
    // }

    setTimeout(() => {
      if (this.$route.query.from) {
        const element = document.getElementById("event-section");
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 101);
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
    FlowParticipation,
    NoticeList,
    EventList,
    TokyoMarathonFoundation,
  },
};
</script>

<style scoped>
.slider__list {
  .slider-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    @media screen and (max-width: 350px) {
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/top/Top.vue